import { render } from "./CheckboxButton.vue?vue&type=template&id=61039396&scoped=true"
import script from "./CheckboxButton.vue?vue&type=script&lang=js"
export * from "./CheckboxButton.vue?vue&type=script&lang=js"

import "./CheckboxButton.vue?vue&type=style&index=0&id=61039396&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61039396"]])

export default __exports__